export default __webpack_public_path__ + "videos/OmniSmallPlumeNoSound.de024cc5.mp4";